import React, { Suspense, lazy } from 'react';
import { Page } from '@fiverr-private/perseus';

import Hero from '../components/Hero';
import InspiredByRecentViews from '../components/InspiredByRecentViews';
import SubcategoryCarousel from '../components/SubcategoryCarousel';
import SellingProposition from '../components/SellingProposition';
import Categories from '../components/Categories';
import Context from '../utils/context';
import { isTouchDevice, isTouchDeviceByContext } from '../utils/isTouchDevice';
import {sendMixPanelEvent} from '../utils/biEvents';
import { MP_SHOW_PAGE_NAME } from '../utils/biEvents/events/mixPanelEvents';

import './style.scss';

const MadeOnFiverr = lazy(() => import(/* webpackChunkName: 'MadeOnFiverr' */'../components/MadeOnFiverr'));
const Testimonials = lazy(() => import(/* webpackChunkName: 'Testimonials' */'../components/Testimonials'));
const Pro = lazy(() => import(/* webpackChunkName: 'Pro' */'../components/Pro'));
const BusinessTools = lazy(() => import(/* webpackChunkName: 'BusinessTools' */'../components/BusinessTools'));
const FiverrGuides =  lazy(() => import(/* webpackChunkName: 'FiverrGuides' */'../components/FiverrGuides'));
const Signup = lazy(() => import(/* webpackChunkName: 'Signup' */'../components/Signup'));

class LoggedOutHomepage extends Page {

    constructor(props) {
        super(props);

        const {
            requestContext
        } = this.props;

        this.state = {
            isTouch: isTouchDeviceByContext(requestContext) || false
        };
    }

    componentDidMount() {
        // eslint-disable-next-line
        this.setState({
            isTouch: isTouchDevice()
        });

        sendMixPanelEvent({mpEventType: 'trackPageView', eventName: MP_SHOW_PAGE_NAME});
    }

    render() {
        const { requestContext, viewObject, heroBgColor } = this.props;
        const { isTouch } = this.state;

        return (
            <Context.Provider value={{...requestContext, ...viewObject}}>
                <div className="logged-out-homepage">
                    <Hero bgColor={heroBgColor}/>
                    <div className="max-width-container">
                        <InspiredByRecentViews isTouch={isTouch}/>
                        <SubcategoryCarousel isTouch={isTouch}/>
                        <SellingProposition/>
                        <Categories/>
                        <Suspense fallback={<div/>}>
                            <MadeOnFiverr isTouch={isTouch}/>
                            <Testimonials isTouch={isTouch}/>
                            <Pro/>
                            <BusinessTools/>
                            <FiverrGuides/>
                            <Signup/>
                        </Suspense>
                    </div>
                </div>
            </Context.Provider>
        );
    }
}

export default LoggedOutHomepage;
